import {billingService} from "../_services";
import {billingConstants} from "../_constants";

export const billingActions = {
    getAllDocuments,
    getDocumentSettings,
    getInvoiceData,
    getCreditNoteData,
    getAllDocumentsForShopify,
};

function getAllDocuments(externalId, integration, shopIdentifier) {
    return (dispatch) => {
        dispatch(request());

        return billingService.getAllDocuments(externalId, integration, shopIdentifier).then(
            (result) => {
                dispatch(success(result));
                return result;
            },
            (error) => {
                if (error.message) {
                    dispatch(failure(error.message));
                } else {
                    dispatch(failure(error));
                }
                return error;
            }
        );
    };

    function request() {
        return {type: billingConstants.GET_ALL_DOCUMENTS_REQUEST};
    }

    function success(result) {
        return {type: billingConstants.GET_ALL_DOCUMENTS_SUCCESS, result};
    }

    function failure(errorMessage) {
        return {type: billingConstants.GET_ALL_DOCUMENTS_FAILURE, errorMessage};
    }
}

function getDocumentSettings(externalUUID, orderDataUUID, wrapperType, originalId) {
    return (dispatch) => {
        dispatch(request());

        return billingService.getDocumentSettings(externalUUID, orderDataUUID, wrapperType, originalId).then(
            (result) => {
                dispatch(success(result));
                return result;
            },
            (error) => {
                if (error.message) {
                    dispatch(failure(error.message));
                } else {
                    dispatch(failure(error));
                }
                return error;
            }
        );
    };

    function request() {
        return {type: billingConstants.GET_ORDER_INVOICING_CONFIGURATION_REQUEST};
    }

    function success(result) {
        return {
            type: billingConstants.GET_ORDER_INVOICING_CONFIGURATION_SUCCESS,
            result,
        };
    }

    function failure(errorMessage) {
        return {
            type: billingConstants.GET_ORDER_INVOICING_CONFIGURATION_FAILURE,
            errorMessage,
        };
    }
}

// Template fetch invoices data to display invoice
function getInvoiceData(uuid) {
    return (dispatch) => {
        dispatch(request());

        return billingService.getInvoiceData(uuid).then(
            (result) => {
                console.log("Fetched invoice successfully");
                dispatch(success(result));
                return result;
            },
            (error) => {
                console.log("Error during invoice fetching");
                if (error.message) {
                    dispatch(failure(error.message));
                } else {
                    dispatch(failure(error));
                }
                return error;
            }
        );
    };

    function request() {
        return {type: billingConstants.GET_INVOICE_DATA_REQUEST};
    }

    function success(result) {
        return {type: billingConstants.GET_INVOICE_DATA_SUCCESS, invoice: result};
    }

    function failure(errorMessage) {
        return {type: billingConstants.GET_INVOICE_DATA_FAILURE, errorMessage};
    }
}

// Template fetch creditnote data to display creditnote
function getCreditNoteData(uuid, refundId) {
    return (dispatch) => {
        dispatch(request());

        return billingService.getCreditNoteData(uuid, refundId).then(
            (result) => {
                console.log("Fetched creditnote successfully");
                dispatch(success(result));
                return result;
            },
            (error) => {
                console.log("Error during creditnote fetching");
                if (error.message) {
                    dispatch(failure(error.message));
                } else {
                    dispatch(failure(error));
                }
                return error;
            }
        );
    };

    function request() {
        return {type: billingConstants.GET_CREDIT_NOTE_DATA_REQUEST};
    }

    function success(result) {
        return {type: billingConstants.GET_CREDIT_NOTE_DATA_SUCCESS, creditNote: result};
    }

    function failure(errorMessage) {
        return {
            type: billingConstants.GET_CREDIT_NOTE_DATA_FAILURE,
            errorMessage,
        };
    }
}

function getAllDocumentsForShopify(shopId, orderId) {
    return (dispatch) => {
        dispatch(request());

        return billingService.getAllDocumentsForShopify(shopId, orderId).then(
            (result) => {
                dispatch(success(result));
                return result;
            },
            (error) => {
                if (error.message) {
                    dispatch(failure("pathway Rechnungsprinter nicht verfügbar"));
                } else {
                    dispatch(failure(error));
                }
                return error;
            }
        );
    };

    function request() {
        return {type: billingConstants.GET_ALL_DOCUMENTS_REQUEST};
    }

    function success(result) {
        return {type: billingConstants.GET_ALL_DOCUMENTS_SUCCESS, result};
    }

    function failure(errorMessage) {
        return {type: billingConstants.GET_ALL_DOCUMENTS_FAILURE, errorMessage};
    }
}
